/** The result of {@link checkItemName}: the name to use, or why it can't be used. */
export type ItemNameCheck = {ok: true; name: string} | {ok: false; error: string}

// eslint-disable-next-line no-control-regex
const CONTROL_CHARS = /[\u0000-\u001f\u007f]/

/**
 * The name of a new folder, or the new name of a file or folder, as typed.
 *
 * Spaces at either end are dropped: `cloud:` paths in the CLI, the MCP server and the AI agent trim
 * them, so a folder named `"Data "` could not be reached from there. Spaces inside a name are kept.
 * A name is one path segment, so `/`, `.` and `..` are refused (S3 would read `/` as a folder).
 */
export function checkItemName(input: string): ItemNameCheck {
  const name = input.trim()
  if (!name) return {ok: false, error: 'Enter a name.'}
  if (name.includes('/')) return {ok: false, error: 'A name can’t contain “/”.'}
  if (name === '.' || name === '..') return {ok: false, error: `“${name}” can’t be used as a name.`}
  if (CONTROL_CHARS.test(name))
    return {ok: false, error: 'A name can’t contain control characters.'}
  return {ok: true, name}
}
